/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_SendingInputs */

const zh_auth_sending = /** @type {(inputs: Auth_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送中...`)
};

const en_auth_sending = /** @type {(inputs: Auth_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending...`)
};

const es_auth_sending = /** @type {(inputs: Auth_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando...`)
};

/**
* | output |
* | --- |
* | "Sending..." |
*
* @param {Auth_SendingInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_sending = /** @type {((inputs?: Auth_SendingInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_SendingInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_sending(inputs)
	if (locale === "en") return en_auth_sending(inputs)
	return es_auth_sending(inputs)
});